import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
   <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/70 shadow-md backdrop-blur-md' : 'bg-transparent'}`}>
  <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
    <a href="/" className="flex items-center space-x-3">
      <img src="/logo/Images/327357076_1589148954925021_416533099275302348_n (2).jpg" alt="Ceyone Logo" className="h-10 w-10 sm:w-auto" />
      <span className={`self-center text-2xl font-bold whitespace-nowrap ${isHome ? 'text-white' : 'text-blue-900'}`}>
        Ceyone Foundations
      </span>
        </a>

        <button
          type="button"
          className={`inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg lg:hidden hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400 ${isHome ? 'text-white' : 'text-blue-900'}`}
          onClick={toggleMenu}
          aria-controls="navbar-menu"
          aria-expanded={isOpen}
        >
          <span className="sr-only">Toggle main menu</span>
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div
          className={`w-full lg:block lg:w-auto transition-all duration-300 ${isOpen ? 'block' : 'hidden'}`}
          id="navbar-menu"
        >
          <ul className={`font-medium flex flex-col p-4 lg:p-0 mt-4 rounded-lg ${isHome ? 'bg-transparent' : 'bg-white'} lg:flex-row lg:space-x-8 lg:mt-0 lg:bg-transparent`}>
            <li>
              <a href="/" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
                Home
              </a>
            </li>
            <li>
              <a href="/about" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
                About
              </a>
            </li>
            <li>
              <a href="/services" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
                Service
              </a>
            </li>
             <li>
              <a href="/partners" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
               Partner
              </a>
            </li>
            <li>
              <a href="/gallery" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
                Gallery
              </a>
            </li>
            <li>
              <a href="/contact" className={`block py-2 px-3 ${isHome ? 'text-white' : 'text-blue-900'} hover:text-blue-400`}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
